export default __webpack_public_path__ + "static/media/Ballroll_00066.fcc951f4.png";